import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { PreparationHDModel } from 'src/app/models/PreparationHDModel';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { formatDate } from '@angular/common';
import { TransactionsService } from 'src/app/services/TransactionsService';
import { TransactionsModel } from 'src/app/models/TransactionsModel';
import { DrugInteractionSevice } from 'src/app/services/DrugInteractionSevice';
import { DrugInteractionModel } from 'src/app/models/DrugInteractionModel';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-drug-interaction-view',
  templateUrl: './drug-interaction-view.component.html',
  styleUrls: ['./drug-interaction-view.component.css']
})
export class DrugInteractionViewComponent implements OnInit {
  divisitserial = 0 ;
  didescription = '' ;
  dinotes = '' ;
  diimage :any ;
  myimage :any;
  imageSrc;
  imageSource: any;

  sellersPermitFile: any;
  sellersPermitString :any;
  compcode = '1' ;
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  transactionsList: TransactionsModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();
  constructor(public dialogRef: MatDialogRef<DrugInteractionViewComponent>,   ///----------- for searching pop up -----------
  public druginteractionservice: DrugInteractionSevice,
  public druginteraction: DrugInteractionModel,
  public storage: LocalStorageService,
  @Inject(MAT_DIALOG_DATA)                                     ///----------- for searching pop up -----------
  public druginteractionSelectedData: DrugInteractionModel,
  private sanitizer: DomSanitizer

  ) { }

  ngOnInit(): void {
    this.retriveDrugInteraction();
  }
  retriveDrugInteraction()
  {
     this.druginteractionservice.getDrugInteraction(this.storage.retrieve('stgvisverial'),this.storage.retrieve('stgcpatientCode') ,'1')
    .subscribe((data: DrugInteractionModel) => {

      if (data.divisitserial == null) {

        return;
      }

      this.didescription = data.didescription ;
      this.dinotes = data.dinotes ;
      this.myimage = data.diimage;
      this.sellersPermitString =  data.diimage;
      this.myimage =this.sellersPermitString;
      var kk = this.sellersPermitString;
      this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
    }
    );
  }
  handleInputChange(files: any) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e: any) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.sellersPermitString = base64result;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);


  }

}
